/**
 * Hook to consume pending deep links after successful auth.
 * If a user tapped a push notification while logged out,
 * this redirects them to the intended screen after login completes.
 */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { consumePendingDeepLink } from '@/lib/nativePushNotifications';
import { isNativePushAvailable } from '@/lib/nativePushNotifications';

export function usePendingDeepLink() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const consumed = useRef(false);

  useEffect(() => {
    if (status !== 'authed' || consumed.current) return;
    if (!isNativePushAvailable()) return;

    const pendingLink = consumePendingDeepLink();
    if (pendingLink) {
      console.log('[DeepLink] Consuming pending deep link:', pendingLink);
      consumed.current = true;
      // Small delay to let auth hydration complete
      setTimeout(() => navigate(pendingLink), 300);
    }
  }, [status, navigate]);
}
